import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { map, take } from 'rxjs/operators';
import { DropdownPosition } from 'src/app/components/shared/form/components/form-select/form-select.constants';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';
import { SpecialCharacters } from 'src/app/core/enums';
import { LocationService } from 'src/app/core/services/admin/location/location.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { CONSTS } from './location-form.constants';
@Component({
  selector: 'app-location-form',
  templateUrl: './location-form.component.html',
  styleUrls: ['./location-form.component.scss'],
  standalone: false,
})
export class LocationFormComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) countryList!: IOption[];

  timezoneOptionList!: IOption[];

  readonly CONSTANTS = CONSTS;
  readonly DROPDOWN_POSITION = DropdownPosition.TOP;
  readonly REGEX = SpecialCharacters;

  readonly destroy = inject(DestroyRef);

  constructor(
    public readonly commonUtils: CommonUtils,
    private readonly locationService: LocationService,
  ) {}

  ngOnInit(): void {
    this.getAllTimezones();
  }

  private getAllTimezones() {
    this.locationService
      .getAllTimezones()
      .pipe(
        take(1),
        map((data) => {
          this.timezoneOptionList = data?.response.map(
            (timezone: { itemLabel: string; itemValue: string }) => {
              return {
                label: timezone.itemLabel,
                value: timezone.itemValue,
              };
            },
          );
        }),
      )
      .subscribe();
  }
}
